<template>
  <div>
    <div class="event_list_header">
        <label for="select-field">Select league: </label>
        <select v-model="selectedLeague" id="select-field">
          <option v-for="league in leagues" :key="league.id" :value="league.id">
            {{ league.label}}
          </option>
      </select>
      <!-- Load Button -->
      <button class="load_button" @click="loadData(selectedLeague)">{{ loadButtonLabel }}</button>
    </div>
      <table>
        <thead>
          <tr>
            <th style="min-width: 160px">Date</th>
            <th style="min-width: 92px">ID</th>
            <th style="min-width: 225px">Name</th>
            <th style="min-width: 162px">Generated</th>
            <th v-if="useAgents===true">Generated with Agents</th>
            <th style="min-width: 177px" >Actions</th>
          </tr>
        </thead>
        <tbody v-if="leagueEvents">
          <tr v-for="event in leagueEvents" :key="event.id">
            <td>{{ formatDate(event.scheduled) }}</td>
            <td>{{ event.id }}</td>
            <td>{{ event.name }}</td>
            <td>{{ getMonoButtonLabel(event) }}</td>
            <td v-if="useAgents===true">{{ getAgentsButtonLabel(event) }}</td>
            <td>
              <button @click="generateMono(event.id)" :disabled="generatingDisabled">Generate</button>
              <button v-if="useAgents===true" @click="generateAgents(event.id)" :disabled="generatingDisabled">Generate for Agents</button>
              <button @click="goToEventPage(event.id)">Go To Event</button>
            </td>
          </tr>
        </tbody>
      </table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectedLeague: 'england/premier_league', // This will store the selected ID
      generatingForEvent: null,
      generatingDisabled: false,
      generatingMono: null,
      loadButtonActive: true,
      loadButtonLabel: 'Load',
      useAgents: this.$store.state.useAgents,
      leagues: [
        { id: 'england/premier_league', label: 'England Premier League' },
        { id: 'champions_league', label: 'Champions league' },
        { id: 'netherlands/eredivisie', label: 'Eredivisie' },
        { id: 'sweden/allsvenskan', label: 'Allsvenskan' },
        { id: 'usa/mls', label: 'MLS' },
      ],
    };
  },
  computed: {
    leagueEvents() {
      return this.$store.state.leagueData;
    },
    eventsErrors() {
      return this.$store.state.eventsErrors;
    },
  },
  methods: {
    getMonoButtonLabel(event) {
      if (event.id === this.generatingForEvent) {
        if (this.generatingMono) {
          return "Processing..."; // Mono data is being processed
        } else {
          return "Not Generated"; // Agents data is not being processed
        }
      }
      if (event.mono_data) {
        return this.formatDate(event.mono_data);
      } else if (event.id in this.eventsErrors){
        return this.eventsErrors[event.id]['detail']
      } else {
        return "Not Generated";
      }

    },
    getAgentsButtonLabel(event) {
      // Check if the event ID matches the currently generating event
      if (event.id === this.generatingForEvent) {
        if (this.generatingMono) {
          return "Processing..."; // Mono data is being processed
        } else {
          return "Not Generated"; // Agents data is not being processed
        }
      }
      // Return status based on agents_data
      return event.agents_data ? this.formatDate(event.agents_data) : "Not Generated";
    },
    loadData(leagueID) {
      if (!this.loadButtonActive) return;
      this.loadButtonLabel = 'Loading...'; // Change button label
      this.$store.state.leagueData = null
      this.loadButtonActive = false; // Disable button
      this.$store.dispatch('fetchLeaguesEvents', {
        market: this.$store.state.market, apiKey: this.$store.state.apiKey, leagueId: leagueID, isKSP: this.$store.state.isKSP}
      ).then(() => {
        this.loadButtonLabel = 'Load'; // Reset button label
        this.loadButtonActive = true; // Enable button
      });
    },
   formatDate(dateStr) {
      const options = { year: "numeric", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" };
      return new Date(dateStr).toLocaleString("en-US", options);
    },
    // Trigger mono data generation for an event
    generateMono(eventId) {
      this.generatingMono = true
      this.generatingDisabled = true
      this.generatingForEvent = eventId
      this.$store.dispatch('fetchEventData', {
        eventId: eventId,
        market: this.$store.state.market,
        apiKey: this.$store.state.apiKey,
        service: this.$store.state.service,
        engine: this.$store.state.engine,
        useAgents: false,
        force_service: 'force_mono',
        generate_for_cache: true,
        isKSP: this.$store.state.isKSP,
      }
      ).then(() => {
        this.generatingMono = null;
        this.generatingDisabled = null;
        this.generatingForEvent = true;
      });
    },
    // Trigger agents data generation for an event
    generateAgents(eventId) {
      console.log(`Generating agents data for event ID: ${eventId}`);
      // Add API call or logic here
    },
    goToEventPage(eventId) {
      let url = new URL(window.location.href);
      url.searchParams.set('event_id', eventId);
      window.open(url, '_blank');
      //  this.$store.state.eventData = null
      //  this.$store.state.isLoadingEventData = true
      //  this.$store.state.currentContent = 'content_1'
      //  this.$store.eventId = eventId
      //  this.$store.dispatch('fetchEventData', {
      //   eventId: eventId,
      //   market: this.$store.market,
      //   apiKey: this.$store.apiKey,
      //   service: this.$store.service,
      //   engine: this.$store.engine,
      //   useAgents: false,
      //   force_service: null,
      // });


    },

  }
}
</script>
<style scoped>

.event_list_header {
  padding-bottom: 10px;
  padding-top: 10px;
  gap: 20px;
  display: flex;
}
.load_button {
  right: 5px; /* Positions the button 5px from the right edge */
  padding: 5px 10px; /* Normal button size */
  font-size: 14px; /* Adjusts text size to normal */
  background-color: #758da7; /* Button background color */
  color: white; /* Button text color */
  border: none; /* Removes border */
  border-radius: 4px; /* Slightly rounded corners */
  cursor: pointer; /* Pointer cursor on hover */
}

.load_button:hover {
  background-color: #0056b3; /* Slightly darker background on hover */
}
.load_button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}
</style>